<template>
  <v-dialog v-model="isActive" scrollable persistent>
    <v-card>
      <v-card-title class="px-4" style="text-align: center; display: block; font-size: 17px !important">
        Sua avaliação é muito importante
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-4 pb-1">
        <div class="pb-3">
          <h3>O que achou do atendimento?</h3>
          <v-rating v-model="form.attendance_note" :readonly="loading || !couldEdit" size="33" color="warning" background-color="grey"></v-rating>
        </div>
        <div class="pb-3">
          <h3>O que achou do serviço?</h3>
          <v-rating v-model="form.service_note" :readonly="loading || !couldEdit" size="33" color="warning" background-color="grey"></v-rating>
        </div>
        <div class="pb-3">
          <h3>Você indicaria para um amigo(a)?</h3>
          <v-rating v-model="form.indication_note" :readonly="loading || !couldEdit" size="33" color="warning" background-color="grey"></v-rating>
        </div>
        <div>
          <h3>Gostaria de pontuar algo?</h3>
          <v-textarea
            v-model="form.observation"
            :disabled="loading || !couldEdit"
            :rules="[(v) => (v || '').length <= 200 || 'A observação pode ter até 200 caracteres.']"
            :counter="couldEdit === false ? false : 200"
            :hide-details="!couldEdit"
            class="pt-3"
            outlined
            height="100px"
            color="rgba(0, 0, 0, 0.6)"
            placeholder="Campo opcional..."
          ></v-textarea>
        </div>
        <v-alert v-if="!couldEdit" class="mt-3" color="rgba(0, 0, 0, 0.6)" dark border="left">
          Agradecemos seu feedback! Serviço avaliado em <b>{{ formatCreatedAtDate(form.created_at) }}</b
          >.
        </v-alert>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-btn text :block="!couldEdit" :disabled="loading" @click="close()"> Fechar </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="couldEdit"
          style="color: white"
          depressed
          color="rgba(0, 0, 0, 0.6)"
          :loading="loading"
          :disabled="!form?.indication_note || !form?.attendance_note || !form?.service_note"
          @click="save()"
        >
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import dayjs from 'dayjs';

export default {
  emits: ['close', 'save'],
  props: {
    isActive: {
      type: Boolean,
      required: true
    },
    serviceOrder: {
      type: Object,
      default: () => null
    },
    evaluation: {
      type: Object,
      default: () => null
    }
  },
  watch: {
    isActive(newValue) {
      if (!newValue) return;

      this.couldEdit = !this.evaluation;
      this.form = { ...this.evaluation };
    }
  },
  data() {
    return {
      couldEdit: false,
      loading: false,
      form: {}
    };
  },
  methods: {
    save() {
      this.loading = true;
      this.$http.post(`/service_order/${this.serviceOrder.hash}/evaluation`, this.form).then(() => {
        this.loading = false;
        this.$emit('save');
      });
    },
    close() {
      this.$emit('close');
    },
    formatCreatedAtDate(date) {
      const dayjsDate = dayjs(date);
      return `${dayjsDate.format('DD/MM/YYYY')} às ${dayjsDate.format('HH:mm')}`;
    }
  }
};
</script>

<style scoped lang="scss">
.pulse-evaluation {
  transition: all 0.5s;
  animation: pulser 3s infinite;
}
</style>
